import { Component, input, output, inject, OnInit, computed, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
    selector: 'app-user-entities-form',
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, NgSelectModule],
    templateUrl: './user-entities-form.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./user-entities-form.component.css']
})
export class UserEntitiesFormComponent implements OnInit {
    entitiesAll = input.required<any[]>();
    currentEntitiesIds = input<number[]>([]);
    allowedEntities = input<any[]>([]);

    onSave = output<number[]>();
    onCancel = output<void>();

    formUser: FormGroup;
    private fb = inject(FormBuilder);

    /** Lista estable para ng-select (solo se recalcula si cambian los inputs). */
    processedEntities = computed(() => {
        const all = (this.entitiesAll() || []).filter((e) => e?.isActive !== false);
        const allowed = this.allowedEntities() || [];
        const allowedCodes = new Set(allowed.map((e) => Number(e.code ?? e)));
        const enforceAllow = allowedCodes.size > 0;

        return all.map((entity) => ({
            ...entity,
            label: entity.label || `${entity.code} - ${entity.name || ''}`.trim(),
            disabled: enforceAllow && !allowedCodes.has(Number(entity.code))
        }));
    });

    compareByCode = (a: any, b: any) =>
        a != null && b != null && Number(a.code) === Number(b.code);

    constructor() {
        this.formUser = this.fb.group({
            entities: [[], [Validators.required]]
        });
    }

    ngOnInit() {
        const initialValue = new Set((this.currentEntitiesIds() || []).map(Number));
        const source = this.processedEntities();
        const entitiesSelected = source.filter((e) => initialValue.has(Number(e.code)));
        this.formUser.get('entities')?.setValue(entitiesSelected, { emitEvent: false });
    }

    isEntityAllowed(entity: any): boolean {
        const allowed = this.allowedEntities() || [];
        if (!allowed.length) return true;
        return allowed.some((e) => Number(e.code) === Number(entity.code));
    }

    confirm() {
        if (this.formUser.valid) {
            this.onSave.emit(this.formUser.get('entities')?.value);
        }
    }

    cancel() {
        this.onCancel.emit();
    }

    selectAll() {
        const selectable = this.processedEntities().filter((e) => !e.disabled);
        this.formUser.get('entities')?.setValue(selectable);
    }
}
